import { Controller } from '@hotwired/stimulus';

type ItemElement = HTMLLIElement;

export default class extends Controller {
  static readonly targets = ['item', 'display'];
  static readonly values = {
    inputFormFieldName: String,
  };

  declare displayTarget: HTMLButtonElement;
  declare itemTargets: ItemElement[];
  declare inputFormFieldNameValue: string;

  connect(): void {
    for (const item of this.itemTargets) {
      item.addEventListener('keydown', this.onKeypress);
      item.addEventListener('click', this.handleOnClick);
    }
  }

  private onKeypress = (event: KeyboardEvent) => {
    event.preventDefault();
    switch (event.key) {
      case 'Escape': {
        this.closeMenu();
        break;
      }
      case 'Enter':
      case ' ': {
        this.onClick(event.currentTarget as ItemElement);
        break;
      }
    }
  };

  private handleOnClick = (event: Event) => {
    event.preventDefault();
    this.onClick(event.currentTarget as ItemElement);
  };

  private onClick(element: ItemElement) {
    for (const itemTarget of this.itemTargets) {
      itemTarget.setAttribute('aria-checked', 'false');
    }
    element.setAttribute('aria-checked', 'true');
    this.changeDisplayedContent(element);
    this.changeFormInputValue(element);
    this.closeMenu();
  }

  private changeDisplayedContent(content: ItemElement) {
    this.displayTarget.textContent = '';
    for (const item of content.childNodes) {
      const clonedNode = item.cloneNode(true);
      if (clonedNode.nodeType == Node.ELEMENT_NODE) {
        (clonedNode as HTMLElement).classList.remove('!hidden');
      }
      this.displayTarget.append(clonedNode);
    }
  }

  private changeFormInputValue(content: ItemElement) {
    const selectedElementValue = content.dataset.addressId;
    if (selectedElementValue) {
      const input = document.querySelector(
        `[name="${this.inputFormFieldNameValue}"]`,
      ) as HTMLInputElement;
      if (input) {
        input.value = selectedElementValue;
      }
    }
  }

  private closeMenu() {
    const trigger = new CustomEvent('close-menu');
    window.dispatchEvent(trigger);
  }
}
